import { createAction, createActionGroup, emptyProps } from '@ngrx/store';

import { payload } from 'ish-core/utils/ngrx-creators';

export const salesRepActions = createActionGroup({
  source: 'Sales-Rep',
  events: {
    'Load SalesRep': emptyProps(),
    'Switch Customer': payload<{ customerID: string }>(),
    'Switch Customer Success': emptyProps(),
    'Switch Customer Fail': emptyProps(),
  },
});
export const loadCustomerByAPIToken = createAction('[Customer] Load Customer by API Token');
